import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { TierPriceUnit } from "__generated__/graphql";

const TierPriceUnitSelect = ({ value, onChange, options }: Omit<SelectProps<TierPriceUnit, false>, "fetchOptions"> & { options?: TierPriceUnit[] }) => {
	const fetchOptions = options ? Object.values(options) : Object.values(TierPriceUnit);

	return (
		<Select
			fetchOptions={fetchOptions}
			getOptionLabel={(option) => intl.formatMessage({ id: `TIER_PRICE_UNIT_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default TierPriceUnitSelect;
